import type { TranslateFormDraftContentInput } from 'src/graphql';
import { DEFAULT_FORM_EDITING_LOCALE } from './localizedQuestionFieldHelpers';
import { ANSWER_TYPES, OPTION_BASED_TYPES, type QuestionData } from '../types';

function buildTranslateOptions(question: QuestionData) {
  if (!question.questionType || !question.options?.length) {
    return undefined;
  }
  if (
    question.questionType === ANSWER_TYPES.DATA_GRID ||
    OPTION_BASED_TYPES.has(question.questionType)
  ) {
    return question.options.map((option, index) => {
      const text = option.text ?? '';
      // Strip " (optional)" from Other options before translation
      const textForTranslation = option.isOtherOption
        ? text.split(' (')[0]
        : text;

      return {
        optionOrder: index,
        optionText: textForTranslation,
      };
    });
  }
  return undefined;
}

export function buildFormDraftTranslateContentInput(params: {
  targetLanguageCode: string;
  formTitle: string;
  formDescription: string;
  questions: QuestionData[];
}): TranslateFormDraftContentInput {
  const intro = params.formDescription.trim() || null;

  const sorted = [...params.questions].sort(
    (a, b) => (a.order ?? 0) - (b.order ?? 0),
  );

  return {
    sourceLanguageCode: DEFAULT_FORM_EDITING_LOCALE,
    targetLanguageCode: params.targetLanguageCode,
    formTitle: params.formTitle.trim() || null,
    formDescription: params.formDescription.trim() || null,
    introduction: intro,
    questions: sorted.map((q) => ({
      orderIndex: q.order,
      questionText: q.questionText ?? '',
      description: q.description?.trim() ? q.description : null,
      options: buildTranslateOptions(q),
    })),
  };
}
